"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationApi = exports.RegistrationProcess = void 0;
const axios_1 = require("axios");
const globalImportUrl = require("url");
const base_1 = require("../base");
var RegistrationProcess;
(function (RegistrationProcess) {
    RegistrationProcess["Regular"] = "regular";
    RegistrationProcess["Invitation"] = "invitation";
    RegistrationProcess["Sec"] = "sec";
    RegistrationProcess["Cac"] = "cac";
    RegistrationProcess["RegularCac"] = "regular_cac";
    RegistrationProcess["Student"] = "student";
})(RegistrationProcess = exports.RegistrationProcess || (exports.RegistrationProcess = {}));
function RegistrationApiAxiosParamCreator(configuration) {
    return {
        register(Register, options = {}) {
            if (Register === null || Register === undefined) {
                throw new base_1.RequiredError("Register", "Required parameter Register was null or undefined when calling register.");
            }
            const localVarPath = `/account/register`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            const needsSerialization = typeof Register !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(Register !== undefined ? Register : {})
                : Register || "";
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        resendActivation(resend, options = {}) {
            if (resend === null || resend === undefined) {
                throw new base_1.RequiredError("Resend", "Required parameter Resend was null or undefined when calling resendActivation.");
            }
            const localVarPath = `/account/resend-activation`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            const needsSerialization = typeof resend !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(resend !== undefined ? resend : {})
                : resend || "";
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getRegistrationTokens(options = {}) {
            const localVarPath = `/account/registration-tokens`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        insertRegistrationToken(LightRegistrationToken, options = {}) {
            if (LightRegistrationToken === null ||
                LightRegistrationToken === undefined) {
                throw new base_1.RequiredError("LightRegistrationToken", "Required parameter LightRegistrationToken was null or undefined when calling insertRegistrationToken.");
            }
            const localVarPath = `/account/registration-tokens`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            const needsSerialization = typeof LightRegistrationToken !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(LightRegistrationToken !== undefined ? LightRegistrationToken : {})
                : LightRegistrationToken || "";
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        isEligiblePro(email, options = {}) {
            if (email === null || email === undefined || email === '') {
                throw new base_1.RequiredError("email", "Required parameter email was null or undefined or empty when calling isEligiblePro.");
            }
            const localVarPath = `/account/eligible-pro`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            const needsSerialization = localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(email !== undefined ? { email: email } : {})
                : { email: email } || "";
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
}
function RegistrationApiFp(configuration) {
    return {
        getRegistrationTokens(options) {
            const localVarAxiosArgs = RegistrationApiAxiosParamCreator(configuration).getRegistrationTokens(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        register(Register, options) {
            const localVarAxiosArgs = RegistrationApiAxiosParamCreator(configuration).register(Register, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        insertRegistrationToken(LightRegistrationToken, options) {
            const localVarAxiosArgs = RegistrationApiAxiosParamCreator(configuration).insertRegistrationToken(LightRegistrationToken, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        resendActivation(Resend, options) {
            const localVarAxiosArgs = RegistrationApiAxiosParamCreator(configuration).resendActivation(Resend, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        isEligiblePro(email, options) {
            const localVarAxiosArgs = RegistrationApiAxiosParamCreator(configuration).isEligiblePro(email, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
}
class RegistrationApi extends base_1.BaseAPI {
    getRegistrationTokens(options) {
        return RegistrationApiFp(this.configuration).getRegistrationTokens(options)(this.axios, this.basePath);
    }
    insertRegistrationToken(LightRegistrationToken, options) {
        return RegistrationApiFp(this.configuration).insertRegistrationToken(LightRegistrationToken, options)(this.axios, this.basePath);
    }
    register(Register, options) {
        return RegistrationApiFp(this.configuration).register(Register, options)(this.axios, this.basePath);
    }
    resendActivation(Resend, options) {
        return RegistrationApiFp(this.configuration).resendActivation(Resend, options)(this.axios, this.basePath);
    }
    isEligiblePro(email, options) {
        return RegistrationApiFp(this.configuration).isEligiblePro(email, options)(this.axios, this.basePath);
    }
}
exports.RegistrationApi = RegistrationApi;
